<template>
    <div>
        <app-sub-title text="Ingresos finalizados de vehículos de carga"/>
        <app-cargo-vehicle-entries-filters
            @filter="onFilter"
            :authors="authors"
            :haveAClient="haveAClient"
            :showExport="false"
        />
        <app-cargo-vehicle-departures-list
            :data="data"
            @change-page="changePage"
            @sort="onSort"
            @see-card="seeCard"
        />

        <!-- inicio de pop ups -->

        <app-pop-up size="large" title="Ingreso de vehículo de carga" id="cargo-vehicle-entry-card">
            <div slot="body">
                <app-card-vehicle-entry v-if="selectedEntry" :vehicle-entry="selectedEntry"/>
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->     
        
    </div>  
</template>

<script>
import CargoVehicleDeparturesList from './CargoVehicleDeparturesList/CargoVehicleDeparturesList.vue';
import CargoVehicleEntriesFilters from '../../Entry/CargoVehicle/CargoVehicleEntriesFilters/CargoVehicleEntriesFilters.vue';
import cargoVehicleEntriesRepository from '../../../../../repositories/cargoVehicleEntries.repository';
import CardVehicleEntry from './CardCargoVehicleEntry/CardCargoVehicleEntry';
export default {
    components: {
        appCargoVehicleDeparturesList: CargoVehicleDeparturesList,
        appCargoVehicleEntriesFilters: CargoVehicleEntriesFilters,
        appCardVehicleEntry: CardVehicleEntry
    },
    data(){
        return {
            haveAClient: false,
            data: {},
            authors: [],
            selectedEntry: '',
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc'
            },
            theFilters: {},
            page: 1,
        }
    },

    methods: {
        loadCargoVehicleEntries(){
            const cver = {...cargoVehicleEntriesRepository};
            if(this.haveAClient){
                const filters = {...this.theFilters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir, client: this.client.id };
                cver.loadCompleteCargoVehicleEntries(filters, this.page)
                .then(({data}) => {
                    this.data = data;
                })
                .catch(error => {
                    toastr.error('Error al cargar los ingresos de vehículos de carga');
                });
            }else{
                const filters = {...this.theFilters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
                cver.loadCompleteCargoVehicleEntries(filters, this.page)
                .then(({data}) => {
                    this.data = data;
                })
                .catch(error => {
                    toastr.error('Error al cargar los ingresos de vehículos de carga');
                });
            }
        },
        changePage(page){
            this.page = page;
            this.loadCargoVehicleEntries();
        },
        loadAuthorsCargoVehicleEntries() {
            const cver = {...cargoVehicleEntriesRepository};
            cver.loadCargoVehicleEntriesAuthors()
            .then(({data}) => this.authors = data)
            .catch(error =>
                toastr.error( "Ocurrió un error al cargar los autores")
            );
        },
        seeCard(cargoVehicleEntry){
            this.selectedEntry = cargoVehicleEntry;
            this.$bus.$emit('cargo-vehicle-entry-card.open');
        },
        onFilter(filters){
            this.theFilters = filters;
            this.loadCargoVehicleEntries();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadCargoVehicleEntries();
        },
        initialize(){
            this.loadCargoVehicleEntries();
            this.loadAuthorsCargoVehicleEntries();
        }
    },
    created(){
        this.haveAClient = this.client ? true: false;
        this.initialize();
    }
}
</script>
